
'use client'
import React, { useState, useEffect } from 'react';

export default function IranijaFooterResponsive() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ fontFamily: 'Vazir, Tahoma, Arial, sans-serif', direction: 'rtl' }}>
      {isMobile ? <MobileView /> : <DesktopView />}
    </div>
  );
}

// ==========================================
// ۱. نسخه دسکتاپ
// ==========================================
const DesktopView = () => {
  return (
    <div style={{ backgroundColor: '#fff', width: '100%', overflowX: 'hidden' }}>
      <div style={{ height: '100px',  backgroundColor: '#f5f6f8', width: '100%' }}></div>

      <footer style={{
        backgroundColor: '#f5f6f8',
        position: 'relative',
        width: '100%',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        borderTop: '1px solid #e1e1e1'
      }}>
        
        <div style={{ maxWidth: '1250px', margin: '0 auto', padding: '0 15px', width: '100%', boxSizing: 'border-box' }}>
          
          {/* باکس آبی پشتیبانی */}
          <div style={{
            background: '#082046',
            borderRadius: '15px',
            padding: '25px 40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative',
            color: '#fff',
            marginTop: '-50px',
            marginBottom: '60px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
          }}>
            {/* <span style={{ position: 'absolute', top: '15px', left: '20px', fontSize: '20px', cursor: 'pointer', opacity: 0.8 }}>✕</span> */}

            <div style={{ textAlign: 'right' }}>
              <h2 style={{ fontSize: '22px', fontWeight: 'bold', margin: '0 0 10px 0' }}>پشتیبانی و مشاوره تلفنی</h2>
              <p style={{ fontSize: '14px', margin: 0, opacity: 0.9 }}>
                جهت مشاوره برای خرید و رزرو هتل‌های مشهد شماره همراه خود را وارد کنید، به زودی با شما تماس می‌گیریم.
              </p>
            </div>

            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
               <button style={{
                 backgroundColor: '#66a103',
                 color: 'white',
                 border: 'none',
                 borderRadius: '8px',
                 padding: '0 30px',
                 height: '45px',
                 fontSize: '14px',
                 fontWeight: 'bold',
                 cursor: 'pointer',
                 fontFamily: 'inherit'
               }}>
                 ارسال
               </button>

               <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <input 
                    type="text" 
                    placeholder="تلفن تماس" 
                    style={{
                      padding: '0 35px 0 10px',
                      borderRadius: '8px',
                      border: 'none',
                      height: '45px',
                      width: '220px',
                      fontSize: '13px',
                      textAlign: 'right',
                      outline: 'none',
                      color: '#333',
                      fontFamily: 'inherit'
                    }}
                  />
                  <img 
                    src="/icons/phone.png" 
                    alt="phone" 
                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', width: '18px', height: '18px', opacity: 0.6 }} 
                  />
               </div>
            </div>
          </div>

          {/* ردیف میانی */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '60px' }}>
            
            <div style={{ width: '50%', textAlign: 'right', paddingTop: '10px' }}>
              <p style={{ fontSize: '14px', color: '#444', marginBottom: '15px', fontWeight: 'bold' }}>برای دریافت آخرین به روزرسانی ها و اخبار ثبت نام کنید!</p>
              <div style={{ 
                border: '1px solid #d1d5db', 
                backgroundColor: '#fff', 
                borderRadius: '12px', 
                padding: '6px', 
                display: 'flex', 
                alignItems: 'center', 
                width: '100%', 
                maxWidth: '450px' 
              }}>
                <button style={{ 
                    backgroundColor: '#66a103', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '8px', 
                    padding: '8px 25px', 
                    fontSize: '13px', 
                    fontWeight: 'bold', 
                    cursor: 'pointer', 
                    marginLeft: '10px',
                    fontFamily: 'inherit'
                }}>ارسال</button>
                <input 
                    type="email" 
                    placeholder="ایمیل خود را وارد کنید..." 
                    style={{ 
                        flex: '1', 
                        border: 'none', 
                        padding: '8px', 
                        outline: 'none', 
                        fontSize: '13px', 
                        textAlign: 'right', 
                        color: '#666',
                        fontFamily: 'inherit'
                    }} 
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
               <div style={{ marginBottom: '5px' }}>
                 <img 
                    src="/icons/footer-logo.png" 
                    alt="Logo" 
                    style={{ maxWidth: '150px', height: 'auto', display: 'block' }} 
                 />
               </div>
               
               <div style={{ display: 'flex', gap: '15px' }}>
                  <SocialIcon icon="email" />
                  <SocialIcon icon="instagram" />
                  <SocialIcon icon="facebook" />
                  <SocialIcon icon="whatsapp" />
               </div>
            </div>

          </div>

          {/* ستون‌های لینک‌ها */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '30px', marginBottom: '80px', textAlign: 'right' }}>
            
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h4 style={headerStyle}>لینک‌های مفید</h4>
              <ul style={listStyle}>
                {['تماس با ما', 'درباره ما', 'بلاگ', 'سنجش رضایتمندی'].map(item => <li key={item} style={listItemStyle}><a href="#" style={linkStyle}>{item}</a></li>)}
              </ul>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h4 style={headerStyle}>خدمات مشتریان</h4>
              <ul style={listStyle}>
                {['قوانین و مقررات', 'حریم خصوصی', 'راهنمای استرداد', 'پرسش و پاسخ'].map(item => <li key={item} style={listItemStyle}><a href="#" style={linkStyle}>{item}</a></li>)}
              </ul>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h4 style={headerStyle}>اطلاعات تکمیلی</h4>
              <ul style={listStyle}>
                {['گارانتی بهترین نرخ', 'قوانین رزرو', 'نظرات هتل‌ها', 'راهنمای رزرو'].map(item => <li key={item} style={listItemStyle}><a href="#" style={linkStyle}>{item}</a></li>)}
              </ul>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h4 style={headerStyle}>تماس با ما</h4>
              <div style={{ color: '#555', fontSize: '13px', lineHeight: '2.4', textAlign: 'right' }}>
                <p style={{ margin: 0 }}>آدرس: ایران، مشهد، خیابان عنصری، انتهای</p>
                <p style={{ margin: 0 }}>عنصری غربی ۱۴</p>
                <div style={{ margin: '5px 0', direction: 'rtl' }}>
                    <span style={{ fontSize: '12px' }}>ارتباط با مشتریان ۲۴ ساعته: </span>
                    <span style={{ direction: 'ltr', display: 'inline-block' }}>۰۵۱-۳۸۵۱۵۵۲۶</span>
                </div>
                <p style={{ margin: '5px 0 0 0' }}>پست الکترونیکی: info@iranija.com</p>
              </div>
            </div>

          </div>
        </div>

        <div style={{ backgroundColor: '#66a103', padding: '18px 20px', textAlign: 'center', color: 'white', fontSize: '12px', width: '100%', marginTop: 'auto' }}>
          © ۱۴۰۳-۱۴۰۵ ایرانیجا. کلیه حقوق متعلق به آژانس گردشگری ایرانیجا است.
        </div>
      </footer>
    </div>
  );
};

// ==========================================
// ۲. نسخه موبایل - نوار پایین بهبود یافته
// ==========================================
const MobileView = () => {
  const [openSection, setOpenSection] = useState(null);
  const toggleSection = (index) => setOpenSection(openSection === index ? null : index);

  return (
    <div style={{ backgroundColor: '#fff', minHeight: '100vh', paddingBottom: '100px', overflowX: 'hidden', position: 'relative' }}>
      
      {/* باکس آبی پشتیبانی */}
      <div style={{
        background: '#083e68',
        margin: '20px',
        borderRadius: '20px',
        padding: '30px 20px',
        textAlign: 'center',
        color: 'white',
        position: 'relative',
        boxShadow: '0 5px 15px rgba(0,0,0,0.15)'
      }}>
        <span style={{ position: 'absolute', top: '15px', left: '20px', fontSize: '18px', opacity: 0.8, cursor: 'pointer' }}>✕</span>
        
        <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>پشتیبانی و مشاوره تلفنی</h2>
        <p style={{ fontSize: '12px', lineHeight: '1.8', marginBottom: '25px', opacity: 0.9 }}>
          جهت مشاوره برای خرید و رزرو هتل‌های مشهد شماره همراه خود را وارد کنید، به زودی با شما تماس می‌گیریم.
        </p>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button style={{
                backgroundColor: '#ff6b00',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                width: '80px',
                height: '45px',
                fontSize: '13px',
                fontWeight: 'bold',
                fontFamily: 'inherit',
                cursor: 'pointer'
            }}>
                ارسال
            </button>
            
            <div style={{ position: 'relative', flex: 1, maxWidth: '200px' }}>
                <input 
                type="text" 
                placeholder="تلفن تماس" 
                style={{
                    width: '100%',
                    height: '45px',
                    borderRadius: '8px',
                    border: 'none',
                    padding: '0 35px 0 10px',
                    textAlign: 'right',
                    fontSize: '13px',
                    boxSizing: 'border-box',
                    fontFamily: 'inherit',
                    outline: 'none',
                    color: '#333'
                }}
                />
                <img 
                   src="/icons/phone.png" 
                   alt="phone" 
                   style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', width: '20px', height: '20px', opacity: 0.6 }} 
                />
            </div>
        </div>
      </div>

      {/* بخش خبرنامه */}
      <div style={{ padding: '0 20px', marginBottom: '40px', textAlign: 'center' }}>
        <p style={{ fontSize: '13px', fontWeight: 'bold', color: '#444', marginBottom: '15px' }}>
            برای دریافت آخرین به روزرسانی ها و اخبار ثبت نام کنید!
        </p>
        
        <div style={{ 
            border: '1px solid #e5e7eb', 
            borderRadius: '15px', 
            padding: '5px', 
            display: 'flex', 
            alignItems: 'center',
            backgroundColor: 'white',
            height: '50px',
            boxSizing: 'border-box'
        }}>
           <input 
               type="email" 
               placeholder="ایمیل خود را وارد کنید..." 
               style={{ 
                   flex: 1, 
                   border: 'none', 
                   outline: 'none', 
                   textAlign: 'right', 
                   fontSize: '12px', 
                   backgroundColor: 'transparent', 
                   fontFamily: 'inherit',
                   paddingRight: '10px',
                   color: '#555'
               }} 
           />

            <button style={{ 
               backgroundColor: '#66a103',
               color: 'white', 
               border: 'none', 
               borderRadius: '10px', 
               padding: '0 25px', 
               height: '38px', 
               fontSize: '13px', 
               fontWeight: 'bold',
               cursor: 'pointer',
               fontFamily: 'inherit'
           }}>
               ارسال
           </button>
        </div>
      </div>

      {/* منوهای آکاردئونی */}
      <div style={{ padding: '0 10px', borderTop: '1px solid #f0f0f0' }}>
        {[
          { title: 'لینک‌های مفید', items: ['تماس با ما', 'درباره ما', 'بلاگ', 'سنجش رضایتمندی'] },
          { title: 'خدمات مشتریان', items: ['قوانین و مقررات', 'حریم خصوصی', 'راهنمای استرداد', 'پرسش و پاسخ'] },
          { title: 'اطلاعات تکمیلی', items: ['گارانتی بهترین نرخ', 'قوانین رزرو', 'نظرات هتل‌ها', 'راهنمای رزرو'] },
          { title: 'تماس با ما', items: ['آدرس: مشهد، خیابان عنصری', 'تلفن: ۰۵۱-۳۸۵۱۵۵۲۶'] }
        ].map((section, index) => (
          <div key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
            <button 
              onClick={() => toggleSection(index)}
              style={{
                width: '100%',
                padding: '18px 15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'none',
                border: 'none',
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#444',
                fontFamily: 'inherit',
                cursor: 'pointer'
              }}
            >
              <span>{section.title}</span>
              <span style={{ 
                  color: '#66a103', 
                  fontSize: '12px',
                  transform: openSection === index ? 'rotate(180deg)' : 'rotate(0deg)', 
                  transition: 'transform 0.3s' 
              }}>▼</span>
            </button>
            <div style={{ height: openSection === index ? 'auto' : '0', overflow: 'hidden', transition: 'all 0.3s' }}>
                <ul style={{ listStyle: 'none', padding: '0 20px 15px', margin: 0 }}>
                    {section.items.map((item, i) => <li key={i} style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>{item}</li>)}
                </ul>
            </div>
          </div>
        ))}
      </div>

      {/* لوگو */}
      <div style={{ display: 'flex', justifyContent: 'center', margin: '40px 0 20px', flexDirection: 'column', alignItems: 'center' }}>
         <div style={{ width: '80px', height: 'auto', marginBottom: '10px' }}>
             <img 
                src="/icons/footer-logo.png" 
                alt="Iranija Logo" 
                style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
             />
         </div>
      </div>

      {/* آیکون‌های شبکه اجتماعی */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '25px', marginBottom: '30px' }}>
        <SocialIcon icon="whatsapp" isMobile />
        <SocialIcon icon="facebook" isMobile />
        <SocialIcon icon="instagram" isMobile />
        <SocialIcon icon="email" isMobile />
      </div>

      {/* کپی رایت */}
      <div style={{ textAlign: 'center', fontSize: '10px', color: '#999', padding: '0 20px 30px', lineHeight: '1.6' }}>
        © ۱۴۰۳-۱۴۰۴ ایرانیجا. کلیه حقوق متعلق به آژانس گردشگری ایرانیجا است.
      </div>

      {/* نوار ناوبری پایین - بهبود یافته */}
      <div style={{
          position: 'fixed',
          bottom: '15px',
          left: '15px',
          right: '15px',
          backgroundColor: '#fff',
          borderRadius: '50px',
          height: '65px',
          boxShadow: '0 5px 20px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          padding: '0',
          zIndex: 1000,
          boxSizing: 'border-box'
      }}>
          {/* آیتم خانه - فعال */}
          <div style={{ 
              backgroundColor: '#66a103', 
              color: 'white', 
              borderRadius: '40px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              padding: '10px 18px',
              gap: '8px',
              cursor: 'pointer',
              flexShrink: 0
          }}>
              <img src="/icons/home-white.png" alt="home" style={{ width: '20px', height: '20px' }} />
              <span style={{ fontSize: '13px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>خانه</span>
          </div>

          {/* آیتم سفرهای من */}
          <NavItem icon="travel" label="سفرهای من" />

          {/* آیتم اعلان‌ها */}
          <NavItem icon="notif" label="اعلان‌ها" />

          {/* آیتم حساب کاربری */}
          <NavItem icon="user" label="حساب کاربری" />
      </div>

    </div>
  );
};

// کامپوننت آیتم نوار پایین - بهینه شده
const NavItem = ({ icon, label }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: '4px',
    flex: 1,
    minWidth: 0
  }}>
    <img 
      src={`/icons/${icon}.png`} 
      alt={label} 
      style={{ 
        width: '22px', 
        height: '22px', 
        opacity: 0.6,
        flexShrink: 0
      }} 
    />
    <span style={{
      fontSize: '10px',
      fontWeight: 'bold',
      color: '#777',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      textAlign: 'center'
    }}>
      {label}
    </span>
  </div>
);

// ==========================================
// کامپوننت‌های کمکی
// ==========================================

const SocialIcon = ({ icon, isMobile }) => {
  return (
    <a href="#" style={{
      width: isMobile ? '24px' : '35px',
      height: isMobile ? '24px' : '35px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: isMobile ? 0.7 : 1,
      transition: 'opacity 0.2s'
    }}>
      <img 
        src={`/icons/${icon}.png`}
        alt={icon} 
        style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
      />
    </a>
  );
};

// استایل‌های عمومی
const headerStyle = {
  fontSize: '15px',
  fontWeight: 'bold',
  color: '#082046',
  marginBottom: '15px',
  paddingBottom: '8px',
  borderBottom: '2px solid #082046',
  display: 'inline-block',
};

const listStyle = { listStyle: 'none', padding: 0, margin: 0 };
const listItemStyle = { marginBottom: '12px' };
const linkStyle = { color: '#555', textDecoration: 'none', fontSize: '13px', transition: 'color 0.2s' };